import { FooterTotalsResult } from '@teinor/erp/types/company/order/general'
import { FooterOrderTotalNewProps } from '../..'
import { ITDisplayPriceNotRounded } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { OrderHeaderURLs } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { ITDisplayEditFinalPriceFooterBase } from '../../../../OrderTable/TableComponents/OrderTotal/Components/HeaderOrderTotal'
import { BuildedOrder } from '../../../../../../../../baseComponents/TwinTable/types'
import { usePlainMeasureDictionary } from '../../../../../../../../utils/hooks/useMeasureDictionary'
import { Fragment } from 'react'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { faCircleInfo, faCirclePlus } from '@fortawesome/pro-light-svg-icons'
import { TwinIconToolTip } from '../../../../../../../../baseComponents/TwinIcon'
import { ITLayoutTableModalOpen } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { displayFormatedNumber } from '../../../../../../../../utils/globals/numbers'

const FooterOrderRightComponent: React.FC<FooterOrderTotalNewProps> = ({ CurrencyId, totalsOrderTableData, isReadOnly, headerData, setOpenModal, costs, hideLeftFooter, hideFinancialRows, ...rest }) => {
    const widthClassName = hideLeftFooter ? 'w-full' : 'ml-auto w-420'
    return (
        <div className={'footer_order_right_component flex ' + widthClassName}>
            <div className={'flex flex-col footer_order_right_content h-fit gap-y-6 items-end py-16 px-20 rounded-lg bg-gray-F7 ' +  widthClassName}>
                <FooterRightTotalUnitsInput totalsOrderTableData={totalsOrderTableData} />
                <FooterRightSubtotalInput CurrencyId={CurrencyId} totalsOrderTableData={totalsOrderTableData} /> 
                {!hideFinancialRows ? <FooterRightDiscountInput headerData={headerData} setOpenModal={setOpenModal} CurrencyId={CurrencyId} totalsOrderTableData={totalsOrderTableData} isReadOnly={isReadOnly} hideLeftFooter={hideLeftFooter} /> : null}
                {!hideFinancialRows ? <FooterRightRechargesInput headerData={headerData} setOpenModal={setOpenModal} CurrencyId={CurrencyId} totalsOrderTableData={totalsOrderTableData} isReadOnly={isReadOnly} hideLeftFooter={hideLeftFooter} /> : null}
                {headerData?.OrderShipping ? <FooterRightConfigShippingInput headerData={headerData} setOpenModal={setOpenModal} isReadOnly={isReadOnly} totalsOrderTableData={totalsOrderTableData} CurrencyId={CurrencyId} hideLeftFooter={hideLeftFooter} /> : null}
                <FooterRightVatsInfoInput CurrencyId={CurrencyId} totalsOrderTableData={totalsOrderTableData} />
                <FooterRightTotalInputComponent {...{ CurrencyId, totalsOrderTableData, ...rest}} />
            </div>
        </div>
    )
}

interface FooterRightBaseInputProps {
    totalsOrderTableData: FooterTotalsResult
}

const FooterRightTotalUnitsInput: React.FC<FooterRightBaseInputProps> = ({ totalsOrderTableData }) => {
    const measures: any = usePlainMeasureDictionary()
    const renderThis: JSX.Element[] = []
    for (const unit of totalsOrderTableData.typeUnitsUsed) {
        const label = measures[unit]
        renderThis.push(
            <div className='flex w-full items-center' key={unit}>
                <div className='regular12'>{label}</div>
                <div className='flex flex-auto items-center justify-end'>{displayFormatedNumber(totalsOrderTableData?.totals?.units[unit])}</div>
            </div>
        )
    }
    return (
        <Fragment>
            {renderThis}
        </Fragment>
    )
}

interface FooterRightSubtotalInputProps extends FooterRightBaseInputProps {
    CurrencyId: string
}

const FooterRightSubtotalInput: React.FC<FooterRightSubtotalInputProps> = ({ totalsOrderTableData, CurrencyId }) => {
    const { t } = useTwinTranslation()
    const subtotal = totalsOrderTableData?.['totals']?.subtotal
    return (
        <div className='flex w-full items-center'>
            <div className='regular12'>{t('subtotal', 'Subtotal')}</div>
            <ITDisplayPriceNotRounded className='flex flex-auto items-center justify-end' value={subtotal === 0 ? 0 : subtotal} with_vat={false} CurrencyId={CurrencyId} />
        </div>
    )
}

interface FooterRightDiscountAndReachargesInputProps extends FooterRightBaseInputProps {
    headerData: TwinDictionary
    setOpenModal: (value: React.SetStateAction<ITLayoutTableModalOpen>) => void
    CurrencyId: string
    isReadOnly?: boolean
    hideLeftFooter?: boolean
}

const FooterRightDiscountInput: React.FC<FooterRightDiscountAndReachargesInputProps> = ({ headerData, setOpenModal, CurrencyId, totalsOrderTableData, isReadOnly, hideLeftFooter }) => {
    const { t } = useTwinTranslation()
    const showIcon = totalsOrderTableData?.totals?.discounts_before || !isReadOnly
    return (
        <div className='flex w-full'>
            <div className='flex items-center'>
                <div className='regular12'>{t('discounts', 'Descuentos')}</div>
                {showIcon && !hideLeftFooter ? <TwinIconToolTip className='text-green-21 ml-8' icon={!isReadOnly ? faCirclePlus : faCircleInfo} message={!isReadOnly ? t('addEditDiscount', 'Añadir o editar descuento') : t('seeDiscountsInfo', 'Ver descuentos')} id='iconAddDiscountFooter' onClick={() => setOpenModal({ type: 'addDiscount', allRowData: headerData })} /> : null}
            </div>
            <ITDisplayPriceNotRounded className='flex flex-auto items-center justify-end' value={totalsOrderTableData?.totals?.discounts_before} with_vat={false} CurrencyId={CurrencyId} />
        </div>
    )
}

const FooterRightRechargesInput: React.FC<FooterRightDiscountAndReachargesInputProps> = ({ headerData, setOpenModal, CurrencyId, totalsOrderTableData, isReadOnly, hideLeftFooter }) => {
    const { t } = useTwinTranslation()
    const showIcon = totalsOrderTableData?.totals?.recharge_before || !isReadOnly
    return (
        <div className='flex w-full'>
            <div className='flex items-center'>
                <div className='regular12'>{t('recharges', 'Recargos')}</div>
                {showIcon && !hideLeftFooter ? <TwinIconToolTip className='text-green-21 ml-8' icon={!isReadOnly ? faCirclePlus : faCircleInfo} message={!isReadOnly ? t('addEditRecharge', 'Añadir o editar recargo') : t('seerechargesInfo', 'Ver recargos')} id='iconAddRechargeFooter' onClick={() => setOpenModal({ type: 'addRecharge', allRowData: headerData })} /> : null}
            </div>
            <ITDisplayPriceNotRounded className='flex flex-auto items-center justify-end' value={totalsOrderTableData?.totals?.recharge_before} with_vat={false} CurrencyId={CurrencyId} />
        </div>
    )
}

interface FooterRightConfigShippingInputProps extends FooterRightBaseInputProps {
    headerData: TwinDictionary
    setOpenModal: (value: React.SetStateAction<ITLayoutTableModalOpen>) => void
    isReadOnly?: boolean
    CurrencyId: string
    hideLeftFooter?: boolean
}

const FooterRightConfigShippingInput: React.FC<FooterRightConfigShippingInputProps> = ({ headerData, setOpenModal, isReadOnly, totalsOrderTableData, CurrencyId, hideLeftFooter }) => {
    const { t } = useTwinTranslation()
    const isShipping = headerData?.typeShipping === 0 || headerData?.typeShipping
    const text = isShipping ? t('noShippingTax', 'Sin gastos de envío') : t('configShippingType', 'Configura el tipo de envío')
    let renderShippingValue: JSX.Element | null = <div className='flex flex-auto regular12 items-center justify-end'>{text}</div>
    
    for (const key in totalsOrderTableData['vat']) {
        if (key.startsWith('SHIPPING')) {
            const element = totalsOrderTableData['vat'][key];
            if (element?.subTotalAfter) {
                renderShippingValue = <ITDisplayPriceNotRounded className='flex flex-auto items-center justify-end' value={element?.subTotalAfter} with_vat={false} CurrencyId={CurrencyId} />
            }
        }
    }
    return (
        <div className='flex w-full'>
            <div className='flex items-center'>
                <div className='regular12'>{t('transport', 'Transporte')}</div>
                {!hideLeftFooter ? <TwinIconToolTip className='text-green-21 ml-8' icon={!isReadOnly ? faCirclePlus : faCircleInfo} message={!isReadOnly ? t('editShipping', 'Editar método de envío') : t('seeShippingInfo', 'Ver información sobre el transporte')} id='iconEditShippingFooter' onClick={() => setOpenModal({ type: 'configShipping', allRowData: headerData })} /> : null}
            </div>
            {renderShippingValue}
        </div>
    )
}

interface FooterRightVatsInfoInputProps extends FooterRightBaseInputProps {
    CurrencyId: string
}

const FooterRightVatsInfoInput: React.FC<FooterRightVatsInfoInputProps> = ({ totalsOrderTableData, CurrencyId }) => {
    const { t } = useTwinTranslation()
    const renderVats: JSX.Element[] = []
    for (const key in totalsOrderTableData?.groupByVat) {
        const element = totalsOrderTableData?.groupByVat?.[key];
        if (element?.taxUsed !== 0) {
            renderVats.push(
                <div className='flex w-full items-center' key={key}>
                    <div className='flex items-center gap-x-5'>
                        <div className='regular12'>{t('vat', 'Impuesto')}</div>
                        <div>{'(' + element?.taxUsed + '%)'}</div>
                    </div>
                    <ITDisplayPriceNotRounded value={element?.vatMoney} className='flex flex-auto items-center justify-end' with_vat={false} CurrencyId={CurrencyId} />
                </div>
            )
        }
    }
    return (
        <div className='flex w-full flex-col items-center mt-3 gap-y-6 py-3 border-t border-gray-D6'>
            <div className='flex w-full mt-4 items-center'>
                <div className='medium12'>{t('totalWithoutVat', 'Base imponible')}</div>
                <ITDisplayPriceNotRounded className='flex flex-auto medium14 items-center justify-end' value={totalsOrderTableData?.['totals']?.subTotalAfter} with_vat={false} CurrencyId={CurrencyId} />
            </div>
            {renderVats}
        </div>
    )
}

interface FooterRightTotalInputComponentProps {
    skipEdit: boolean
    orderStatusDict: TwinDictionary
    orderStatus: any
    orderHeaderURLs: OrderHeaderURLs
    OrderId: any
    OrderFinancialRows: any
    totalsOrderTableData: FooterTotalsResult
    CurrencyId: string
    getCompleteData: (order?: BuildedOrder) => Promise<void>
}

const FooterRightTotalInputComponent: React.FC<FooterRightTotalInputComponentProps> = ({ CurrencyId, OrderFinancialRows, OrderId, orderHeaderURLs, orderStatus, orderStatusDict, skipEdit, totalsOrderTableData, getCompleteData }) => {
    let renderFinalPrice: JSX.Element = <ITDisplayPriceNotRounded value={totalsOrderTableData?.totals?.total} with_vat={false} CurrencyId={CurrencyId} className='medium24 flex justify-end flex-auto w-1' />
    if (orderStatus === orderStatusDict['creating']) {
        renderFinalPrice = <ITDisplayEditFinalPriceFooterBase OrderId={OrderId} value={totalsOrderTableData?.totals?.total} CurrencyId={CurrencyId} getCompleteData={getCompleteData} OrderFinancialRows={OrderFinancialRows} beforeTax={false} orderHeaderURLs={orderHeaderURLs} skipEdit={skipEdit} />
    }
    return (
        <div className='flex w-full h-fit pt-5 gap-x-15 items-center border-t border-gray-D6 footer_right_total_input'>
            <div className='medium16 uppercase'><TwinTrans transKey='total'>Total</TwinTrans></div>
            {renderFinalPrice}
        </div>
    )
}

export default FooterOrderRightComponent